import { errorHandler } from 'hooks/errorHandler'
import { CIMSCommentProps } from './types'
import CIMSTextArea from '../CIMSTextArea'

const CIMSComment: React.FC<CIMSCommentProps> = ({
  children: _,
  showLabel,
  onChange,
  ...rest
}) => {
  return (
    <CIMSTextArea
      {...rest}
      maxLength={1000}
      rows={1}
      onChange={(e) => {
        if (e.target.value && !e.target.value.trim().length)
          return errorHandler('Invalid comment', [
            'Comments cannot contain only whitespace',
          ])
        onChange?.(e)
      }}
    />
  )
}

export default CIMSComment
